module.exports = __webpack_public_path__ + "static/media/posterMobileSecond.8f230a75.webp";